import { render, staticRenderFns } from "./_BateriaQuestaoCadastro.vue?vue&type=template&id=65ce18ab&scoped=true"
import script from "./_BateriaQuestaoCadastro.vue?vue&type=script&lang=ts"
export * from "./_BateriaQuestaoCadastro.vue?vue&type=script&lang=ts"
import style0 from "./_BateriaQuestaoCadastro.vue?vue&type=style&index=0&id=65ce18ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce18ab",
  null
  
)

export default component.exports